import React from "react";
import PageHero from "../components/PageHero";
import ModulesGrid from "../components/ModulesGrid";
import CtaBanner from "../components/CtaBanner";

function ProductModules() {
  return (
    <>
      <PageHero
        eyebrow="Product / Modules"
        title="Every module in MPeoples HRMS"
        subtitle="Grouped by where they sit in the day-to-day attendance and HR workflow — from login to the Admin Dashboard."
      />
      <section className="section">
        <div className="container">
          <ModulesGrid grouped />
        </div>
      </section>
      <CtaBanner />
    </>
  );
}

export default ProductModules;
